import { Component, OnInit, AfterContentInit } from "@angular/core";
import {
  AbstractControl,
  FormControl,
  FormGroup,
  Validators,
  FormBuilder,
} from "@angular/forms";
import { ToastrService } from "ngx-toastr";
import { SpvAcompanhar } from "src/app/models/spv-acompanhar.model";
import { UsuarioCB } from "src/app/models/usuario-cb.model";
import { PTService } from "../pt.service";
import { UsuarioService } from "src/app/services/usuario.service";
import { SCAMP_API_RPT } from "src/environments/environment";
import { UsuarioAutorizacoes } from "src/app/models/usuario.autorizacoes.model";
import { DatePipe } from "@angular/common";
import { CentroCusto } from "src/app/models/centrocusto.model";
import { CentroCustoService } from "src/app/services/centro.custo.service";
import { ParametersOS } from "../../domain/viewmodels.models";
import { APP_SETTINGS } from "src/environments/environment";
import { CORES_STATUS_OS } from 'src/app/shareds/constantes'

@Component({
  selector: "app-acompanhar-pt",
  templateUrl: "./acompanhar-pt.component.html",
})
export class AcompanharPtComponent implements OnInit, AfterContentInit {
  constructor(
    private ptService: PTService,
    private usuarioService: UsuarioService,
    private toastr: ToastrService,
    private formBuilder: FormBuilder,
    private centroCustoService: CentroCustoService
  ) { }

  pts: SpvAcompanhar[] = [];
  voids: string[] = [];
  maximoLinhas: number = 9;
  usuarios: UsuarioCB[] = [];
  bgStatus: string[] = [
    "",
    "#11ffee00;",
    "#70ad47",
    "#a94442",
    "#5b9bd5",
    "#133050",
    "#a94442",
  ]; // Cores representativas para cada status de uma SS

  bgStatusOS: string[] = CORES_STATUS_OS;

  isPesquisando: boolean = false; // indica se a aplicação esta no estado de buscando dados
  autorizacoes: UsuarioAutorizacoes;
  autorizacaoPTOutrosUsuarios: boolean;

  public datePipe = new DatePipe("pt-BR");

  form: FormGroup = null;
  centrosDeCusto: CentroCusto[] = [];
  isProcessing: boolean = false;
  parameters: ParametersOS;
  labelCentroCusto: string = APP_SETTINGS.LabelCentroCusto;

  static dataFinalMenorDoQueDataInicial(group: AbstractControl): {
    [key: string]: boolean;
  } {
    const dataInicial = group.get("dataInicial");
    const dataFinal = group.get("dataFinal");

    if (!dataInicial || !dataFinal) {
      return undefined;
    }

    if (Date.parse(dataFinal.value) < Date.parse(dataInicial.value)) {
      return { dtFinalMenorDtInicial: true };
    }

    return undefined;
  }

  static dataInicioMuitoAntiga(group: AbstractControl): {
    [key: string]: boolean;
  } {
    const dataInicial = group.get("dataInicial");

    if (!dataInicial) {
      return undefined;
    }

    const NumberDataInicial = Date.parse(dataInicial.value);

    if (NumberDataInicial < 0) {
      return { dtInicioMuitoAntiga: true };
    }

    return undefined;
  }

  static dataFinalMuitoAntiga(group: AbstractControl): {
    [key: string]: boolean;
  } {
    const dataFinal = group.get("dataFinal");

    if (!dataFinal) {
      return undefined;
    }

    const NumberDataFinal = Date.parse(dataFinal.value);

    if (NumberDataFinal < 0) {
      return { dtFinalMuitoAntiga: true };
    }

    return undefined;
  }

  resetForm() {
    this.form = this.formBuilder.group(
      {
        dataInicial: [
          this.datePipe.transform(new Date(), "yyyy-MM-dd"),
          [Validators.required],
        ],
        dataFinal: [
          this.datePipe.transform(new Date(), "yyyy-MM-dd"),
          [Validators.required],
        ],
        usuarioSolicitouId: [this.usuarioService.getUsuarioLogadoId()],
        status: [""],
        usuarioSolicitante: [""],
        statusDescricao: [""],
        centroCustoDescricao: [""],
        centroCustoId: [""],
        tipoData: ["DataHoraUltimoStatus"],
        labelCentroCusto: [this.labelCentroCusto],
      },
      {
        validators: [
          AcompanharPtComponent.dataFinalMenorDoQueDataInicial,
          AcompanharPtComponent.dataInicioMuitoAntiga,
          AcompanharPtComponent.dataFinalMuitoAntiga,
        ],
      }
    );
  }

  ngAfterContentInit(): void {
    this.autorizacoes =
      this.usuarioService.getAutorizacoesJanelaPorRota("acompanhar-pt");
    this.autorizacaoPTOutrosUsuarios =
      this.usuarioService.getAutorizacoesEspecificaPorRota(
        "acompanhar-pt",
        "pt-outros-usuarios"
      );
  }

  ngOnInit() {
    this.resetForm();
    this.setVoids();
    this.getCentroCustos();

    this.usuarioService.getUsuariosCB().subscribe(
      (response) => {
        this.usuarios = response;
      },
      (err: any) => {
        this.toastr.error("Erro ao tentar obter Usuarios Solicitantes");
      }
    );

    document.getElementById("dataInicial").focus();
  }

  getCentroCustos() {
    this.centroCustoService.getCentrosCustos().subscribe(
      (response: CentroCusto[]) => {
        this.centrosDeCusto = response;
      },
      (err: any) => {
        this.toastr.error("Erro ao tentar obter lista de Centros Custos");
      }
    );
  }

  getPtSelecionada(id, modal) {
    // TODO Exibir em um Modal maiores detalhes da PT selecionada
  }

  submit(ocultarMsg: boolean) {
    if (this.form.valid) {
      this.isProcessing = true;

      this.ptService.pesquisarptsPorPeriodo(this.form.value).subscribe(
        (response) => {
          this.pts = response;
          this.setVoids();

          if (this.pts.length == 0) {
            if (ocultarMsg == false) {
              this.toastr.warning(
                "A pesquisa não retornou resultados com os parâmetros fornecidos"
              );
            }
          }

          this.isProcessing = false;
        },
        (err: any) => {
          this.toastr.error("Erro ao tentar obter PTs");
          this.isProcessing = false;
        }
      );
    }
  }

  reset() {
    this.resetForm();
    this.pts = [];
    this.setVoids();
    this.isPesquisando = false;
  }

  changeStatus(status: string) {
    this.form.get("statusDescricao").setValue(status);
  }

  imprimir() {
    this.isPesquisando = true;
    this.submit(true);

    let cmbUsuarioSolicitante = <HTMLSelectElement>(
      document.getElementById("usId")
    );
    let usuarioSolicitante =
      cmbUsuarioSolicitante.options[cmbUsuarioSolicitante.selectedIndex].text;

    this.form.get("usuarioSolicitante").setValue(usuarioSolicitante);

    this.ptService.getAcompanharPTs(this.form.value).subscribe(
      (response) => {
        if (response.success == true) {
          if (response.nenhumResultado == false) {
            window.open(
              `${SCAMP_API_RPT.root}${response.pathRpt}`,
              "_blank",
              "width=760,height=610,resizable=yes,scrollbars=yes,status=1,left=30,top=50,location=no"
            );
          } else {
            this.toastr.warning(response.msgErro);
          }
          this.isPesquisando = false;
        } else {
          this.toastr.error(`${response.msgErro} - ${response.msgException}`);

          this.isPesquisando = false;
        }
      },
      (err: any) => {
        this.toastr.error(
          "Não foi possível se conectar ao servidor de relatórios",
          "Erro de Conexão"
        );
        this.isPesquisando = false;
      }
    );
  }
  private setVoids() {
    this.voids = [];

    if (this.pts.length < this.maximoLinhas) {
      for (let i = this.pts.length; i < this.maximoLinhas; i++) {
        this.voids.push("");
      }
    }
  }

  limparDataListCentroCustos() {
    this.form.get("centroCustoDescricao").setValue("");
    this.form.get("centroCustoId").setValue("");
  }

  changeDataListCentroCustos(value: string) {
    let item;
    if (value != "") {
      item = this.centrosDeCusto.filter((t) =>
        t.nome.toLowerCase().includes(value.toLowerCase())
      )[0];
    }
    if (item != undefined) {
      this.form.get("centroCustoDescricao").setValue(item.nome);
      this.form.get("centroCustoId").setValue(item.id);
    } else {
      this.form.get("centroCustoDescricao").setValue("");
      this.form.get("centroCustoId").setValue("");
    }
  }

  showOS(osId: number, spvId: number) {
    this.parameters = {
      osId: osId,
      spvId: spvId,
    };
  }
}
